import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Link } from "react-router-dom";
import { Briefcase, Users, TrendingUp, Sparkles } from "lucide-react";

const Index = () => {
  return (
    <div className="min-h-screen bg-gradient-subtle">
      {/* Header */}
      <header className="border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
        <div className="container mx-auto px-4 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2">
              <Sparkles className="h-6 w-6 text-primary" />
              <h1 className="text-2xl font-bold bg-gradient-primary bg-clip-text text-transparent">
                RecruitAI
              </h1>
            </div>
            <nav className="flex items-center gap-4">
              <Link to="/jobs">
                <Button variant="ghost">Find Jobs</Button>
              </Link>
              <Link to="/auth">
                <Button variant="outline">Recruiter Login</Button>
              </Link>
            </nav>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <section className="container mx-auto px-4 py-20">
        <div className="max-w-4xl mx-auto text-center space-y-6">
          <h2 className="text-5xl md:text-6xl font-bold tracking-tight">
            Find Your Dream Job with
            <span className="block bg-gradient-primary bg-clip-text text-transparent">
              AI-Powered Precision
            </span>
          </h2>
          <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
            Connect with top companies and let our intelligent platform match you with opportunities that align perfectly with your skills and aspirations.
          </p>
          <div className="flex gap-4 justify-center pt-4">
            <Link to="/jobs">
              <Button size="lg" className="bg-gradient-primary hover:opacity-90">
                <Briefcase className="mr-2 h-5 w-5" />
                Explore Jobs
              </Button>
            </Link>
          </div>
        </div>
      </section>

      {/* Features */}
      <section className="container mx-auto px-4 py-20">
        <div className="grid md:grid-cols-3 gap-8">
          <Card className="p-6 hover:shadow-elegant transition-all">
            <Briefcase className="h-12 w-12 text-primary mb-4" />
            <h3 className="text-xl font-semibold mb-2">Smart Matching</h3>
            <p className="text-muted-foreground">
              Our AI analyzes your resume and matches you with the perfect opportunities.
            </p>
          </Card>
          
          <Card className="p-6 hover:shadow-elegant transition-all">
            <Users className="h-12 w-12 text-primary mb-4" />
            <h3 className="text-xl font-semibold mb-2">Top Companies</h3>
            <p className="text-muted-foreground">
              Access exclusive opportunities from leading companies across industries.
            </p>
          </Card>
          
          <Card className="p-6 hover:shadow-elegant transition-all">
            <TrendingUp className="h-12 w-12 text-primary mb-4" />
            <h3 className="text-xl font-semibold mb-2">Career Growth</h3>
            <p className="text-muted-foreground">
              Get personalized insights and recommendations to accelerate your career.
            </p>
          </Card>
        </div>
      </section>

      {/* CTA */}
      <section className="container mx-auto px-4 py-20">
        <Card className="p-12 bg-gradient-primary text-white text-center">
          <h2 className="text-3xl font-bold mb-4">Ready to Start Your Journey?</h2>
          <p className="text-lg mb-6 opacity-90">
            Join thousands of professionals who found their perfect role through RecruitAI
          </p>
          <Link to="/jobs">
            <Button size="lg" variant="secondary">
              View Open Positions
            </Button>
          </Link>
        </Card>
      </section>

      {/* Footer */}
      <footer className="border-t py-8 bg-background">
        <div className="container mx-auto px-4 text-center text-muted-foreground">
          <p>© 2024 RecruitAI. Powered by AI, built for talent.</p>
        </div>
      </footer>
    </div>
  );
};

export default Index;
